import React from "react";
import { Link, withStyles, fade, ButtonProps } from "@material-ui/core";
import { LARGE_BUTTON } from "../../theme";
import { ToggleButton } from "@material-ui/lab";

export const TextLink = withStyles((theme) => ({
  root: {
    "&:focus": {
      outline: "none",
    },
  },
}))(Link);

const StyledToggleButton = withStyles((theme) => ({
  root: {
    ...LARGE_BUTTON,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    paddingTop: "7px",
    paddingBottom: "8px",
    "&:hover": {
      backgroundColor: `${fade(theme.palette.primary.main, 0.04)}`,
    },
  },
  selected: {
    color: `${theme.palette.primary.main} !important`,
    backgroundColor: `${fade(theme.palette.primary.main, 0.1)} !important`,
  },
}))(ToggleButton);

export const ViewToggleButton: React.FC<
  {
    value: any;
    label?: string;
    href?: string;
  } & ButtonProps
> = ({ value, href, label, ...props }) => {
  return (
    <StyledToggleButton {...props} value={value} size="large" color="primary">
      <TextLink
        href={href}
        underline="none"
        tabIndex={-1}
        color="primary"
        onClick={(e: any) => e.preventDefault()}
      >
        {label || value}
      </TextLink>
    </StyledToggleButton>
  );
};
